"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallToAction = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var _CallToAction = require("./CallToAction.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CallToAction = function CallToAction(props) {
  var title = props.title,
      description = props.description,
      titleLevel = props.titleLevel,
      buttonText = props.buttonText,
      buttonWidth = props.buttonWidth,
      buttonVariant = props.buttonVariant,
      onButtonClick = props.onButtonClick,
      imageSrc = props.imageSrc,
      a11yImageAlt = props.a11yImageAlt,
      className = props.className,
      id = props.id;
  return _react.default.createElement(_CallToAction.StyledCallToActionWrapper, {
    className: className,
    id: id
  }, imageSrc && _react.default.createElement(_CallToAction.StyledImageContainer, null, _react.default.createElement(_CallToAction.StyledImage, {
    src: imageSrc,
    alt: a11yImageAlt
  })), title && _react.default.createElement(_.Heading, {
    level: titleLevel,
    align: "center"
  }, title), description && _react.default.createElement(_.Text, {
    align: "center",
    tag: "p"
  }, description), buttonText && _react.default.createElement(_CallToAction.StyledButton, {
    primary: buttonVariant === 'primary',
    secondary: buttonVariant === 'secondary',
    tertiary: buttonVariant === 'tertiary',
    width: buttonWidth,
    onClick: onButtonClick
  }, buttonText));
};
/**
 * Definition of default values for component props
 */


exports.CallToAction = CallToAction;
CallToAction.defaultProps = {
  title: undefined,
  description: undefined,
  titleLevel: 'h2',
  buttonText: undefined,
  buttonWidth: 'unset',
  buttonVariant: 'primary',
  imageSrc: undefined,
  a11yImageAlt: undefined,
  className: undefined,
  id: undefined,
  onButtonClick: function onButtonClick() {}
};
/**
 * Definition of types for component props
 */

CallToAction.propTypes = {
  title: _propTypes.default.node,
  description: _propTypes.default.node,
  titleLevel: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  buttonWidth: _propTypes.default.string,
  buttonVariant: _propTypes.default.string,
  imageSrc: _propTypes.default.string,
  a11yImageAlt: _propTypes.default.string,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  onButtonClick: _propTypes.default.func
};